import React from 'react'
import {compact, isEmpty, isArray} from 'lodash'

export default ({
  type,
  label,
  value,
  values,
  children,
  href,
  showNone = false,
  className = '',
  labelClassName = '',
  flexGrow = true,
  rightAligned = false,
  alwaysHorizontal = false
}) => {
  if (!href) {
    switch (type) {
      case 'address':
        href = `https://www.google.co.nz/maps?t=k&q=loc:${value?.replace(/\n/, ' ')}`
        break
      case 'email':
        href = `mailto:${value}`
        break
      case 'tel':
        href = `tel:${value}`
        break
    }
  }

  if (isArray(children)) children = compact(children)

  if (isEmpty(children) && showNone) children = <span className='has-text-grey-light'>None</span>

  if (isEmpty(children) && (!value || value.length === 0) && !values) return null

  return (
    <div className={`field ${alwaysHorizontal ? 'is-horizontal-mobile' : 'is-horizontal'} ${className}`}>
      <div className={`field-label is-small has-text-left is-flex-grow-${flexGrow ? '2' : '0'}`}>
        <label className={`label is-small ${labelClassName}`}>{label}</label>
      </div>
      <div className={`field-body${rightAligned ? ' has-text-right' : ''}`}>
        <div style={{wordBreak: 'break-word', whiteSpace: 'pre-wrap', width: '100%'}}>
          {values ? (
            Object.values(values)
              .filter(v => !!v)
              .join(' ')
          ) : children ? (
            children
          ) : value && href ? (
            <a href={href} target='_blank'>
              {value}
            </a>
          ) : (
            value
          )}
        </div>
      </div>
    </div>
  )
}
